import * as React from 'react'

import { Minus, Plus } from 'lucide-react'

import { Button } from '~/client/src/shared/components/Button/Button'

interface IZoomPillProps {
  onZoomIn: () => void
  onZoomOut: () => void
}

const ZOOM_BTN = 'tw:size-[30px] tw:rounded-full tw:text-muted-foreground'

const ZoomPill: React.FC<IZoomPillProps> = ({ onZoomIn, onZoomOut }) => (
  <div
    data-map-control=""
    className="tw:flex tw:flex-col tw:items-center tw:gap-[5px] tw:w-10 tw:py-[7.5px] tw:bg-card tw:border-[1.25px] tw:border-border tw:rounded-[44px] tw:shadow-[0px_1px_2px_rgba(0,0,0,0.3),0px_2px_6px_rgba(0,0,0,0.15)]"
  >
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={ZOOM_BTN}
      onClick={onZoomIn}
      title="Zoom In"
    >
      <Plus />
    </Button>
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={ZOOM_BTN}
      onClick={onZoomOut}
      title="Zoom Out"
    >
      <Minus />
    </Button>
  </div>
)

export default ZoomPill
